import {RemotePostFinishRequestPreview} from 'data/usecases/private/refund/request-preview';
import {PostFinishRequestPreview} from 'domain/usecases/private/refund/request-preview';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {RefundFlowEndPoints} from '../../../endpoints';

export const makePostFinishRequestPreview = (): PostFinishRequestPreview =>
	new RemotePostFinishRequestPreview(
		makeBFFApiUrl(RefundFlowEndPoints.requestPreview),
		makeAuthorizeHttpClientDecorator(),
	);
